(function () {
  if (typeof window === 'undefined') return;

  function init() {
    const resultsEl = document.getElementById('predictive-search');
    const inputEl = document.querySelector('predictive-search input[type="search"]');
    if (!resultsEl || !inputEl) return;

    const initialHTML = resultsEl.innerHTML;
    if (!initialHTML.trim()) return;

    function onInput() {
      if (inputEl.value.trim().length === 0) {
        if (!resultsEl.querySelector('.search-empty')) {
          resultsEl.innerHTML = initialHTML;
        }
      }
    }

    inputEl.addEventListener('input', onInput);
    inputEl.addEventListener('search', onInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
